import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interest',
  templateUrl: './interest.component.html',
  styleUrls: ['./interest.component.css']
})
export class InterestComponent implements OnInit {


  interest = `
  Apart from being a Software Engineer, I enjoy most of my time being
  outdoors. I like to play soccer, cricket and always ready for swimming.

  In the winter, I am a sightseer and likely to explore thing alone like a
  lone ranger. During the warmer months here in Indore, I like to do
  photography and doing frequent road trips.

  When forced indoors, I follow several of sci-fi and fantasy genre movies
  and television shows, I like to play video games (Single as well as
  Multiplayer) and I spend a large amount of my free time exploring the
  latest technology advancements in the world.
  `;

  constructor() { }

  ngOnInit(): void {
  }

}
